import React, { Component, Fragment } from 'react';
import { Row, Col, Input, Button } from 'react-materialize';
import axios from 'axios';
import { defineMessages, injectIntl } from 'react-intl';

import Logger from '../functions/logging';

import '../static/ContactUs.css';

import settings from '../libs/config';

import LandingHeader from '../components/landing/LandingHeader';
import Heading from '../components/global/Heading';
import ContentSection from '../components/landing/ContentSection';
import LandingFooter from '../components/landing/LandingFooter';
import PageLoader from '../components/global/PageLoader';

const localeMessages = defineMessages({
	contact_us_title: {
		id: 'contact_us.title',
		defaultMessage: `Contact Us`,
	},
	contact_us_form_name: {
		id: 'contact_us.form.name',
		defaultMessage: `Name`,
	},
	contact_us_form_email: {
		id: 'contact_us.form.email',
		defaultMessage: `Email`,
	},
	contact_us_form_phone: {
		id: 'contact_us.form.phone',
		defaultMessage: `Phone`,
	},
	contact_us_form_subject: {
		id: 'contact_us.form.subject',
		defaultMessage: `Subject`,
	},
	contact_us_form_message: {
		id: 'contact_us.form.message',
		defaultMessage: `message...`,
	},
	contact_us_button_send: {
		id: 'contact_us.button.send',
		defaultMessage: `Send`,
	},
	contact_us_message_sent: {
		id: 'contact_us.sent',
		defaultMessage: `Message sent`,
	},
	contact_us_message_send_error: {
		id: 'contact_us.error.send',
		defaultMessage: `Message failed to send.`,
	},
	contact_us_error_name: {
		id: 'contact_us.error.name',
		defaultMessage: `Please enter your name before submitting`,
	},
	contact_us_error_email: {
		id: 'contact_us.error.email',
		defaultMessage: `Please enter an email address`,
	},
	contact_us_error_phone: {
		id: 'contact_us.error.phone',
		defaultMessage: `Please enter a phone number`,
	},
	contact_us_error_subject: {
		id: 'contact_us.error.subject',
		defaultMessage: `Please select a relevant subject before submitting`,
	},
	contact_us_error_message: {
		id: 'contact_us.error.message',
		defaultMessage: `Please enter your message`,
	},
});

class ContactUs extends Component {

	constructor(props) {
		super(props);
		let contact = { name: "", company: "", email: "", phone: "", subject: "General Inquiry", message: "" };
		this.state = {
			contact: contact,
			messages: {},
			errors: {},
			loading: false
		};
	}

	componentDidMount() {
		window.$('body').animate({ scrollTop: 0 }, 0);
	}

	validateContactErrors = () => {
		let contact = { ...this.state.contact };
		let errors = {};
		if (!contact.name) {
			errors['name'] = this.props.intl.formatMessage(localeMessages.contact_us_error_name);
		}
		if (!contact.email) {
			errors['email'] = this.props.intl.formatMessage(localeMessages.contact_us_error_email);
		}
		if (!contact.phone) {
			// errors['phone'] = this.props.intl.formatMessage(localeMessages.contact_us_error_phone);
		}
		if (!contact.subject) {
			errors['subject'] = this.props.intl.formatMessage(localeMessages.contact_us_error_subject);
		}
		if (!contact.message) {
			errors['message'] = this.props.intl.formatMessage(localeMessages.contact_us_error_message);
		}
		return Object.keys(errors).length ? errors : false;
	}

	sendMessage = (event) => {
		event.preventDefault();
		
		let contact = { ...this.state.contact };
		let errors = this.validateContactErrors(contact);
		let resetContact = { name: "", email: "", phone: "", subject: "", message: "" };

		if (errors) {
			this.setState({ messages: {}, errors: errors });
			Logger.log(this.constructor.name, "sendMessage() validation errors", errors);
		} 
		else {
			this.setState({ messages: {}, errors: {}, loading: true });
			axios.post(settings.portal_url + '/sendmail', contact)
				.then((response) => {
					Logger.log(this.constructor.name, "sendMessage() response", response);

					if (response.data.sent) {
						const messages = { sendmail: this.props.intl.formatMessage(localeMessages.contact_us_message_sent) };
						this.setState({
							contact: resetContact,
							messages: messages,
							loading: false
						});
					}
					else {
						const errors = { sendmail: this.props.intl.formatMessage(localeMessages.contact_us_message_send_error) };
						this.setState({
							errors: errors,
							loading: false
						});
					}
					// this.props.history.push("/thank-you");
				})
				.catch((error) => {
					const errors = { sendmail: this.props.intl.formatMessage(localeMessages.contact_us_message_send_error) };
					Logger.error(this.constructor.name, "sendMessage() error", error);
					this.setState({ messages: {}, errors, loading: false });
				});
		}

	}

	handleContactChange = (event) => {
		let key = event.target.name;
		let value = event.target.value;
		let contact = { ...this.state.contact };
		contact[key] = value;
		this.setState({ contact: contact });
	}

	closeMessages() {
		this.setState({ messages: {} });
	}

	closeErrors() {
		this.setState({ errors: {} });
	}

	renderMessages = messages => {
		const messagesArray = Object.keys(messages);

		return (
			<div className="card green lighten-5 contact-us-messages">
				<div className="card-content green-text">
					{messagesArray.map(message => {
						return <p key={message} className='contact-us-message-text'>{messages[message]}</p>;
					})}
				</div>
				<Button type="button" className="green-text" data-dismiss="alert" onClick={() => this.closeMessages()}>
					<span>×</span>
				</Button>
			</div>
		);
	}

	renderErrors = errors => {
		const errorsArray = Object.keys(errors);

		return (
			<div className="card red lighten-5 contact-us-errors">
				<div className="card-content red-text">
					{errorsArray.map(error => {
						return <p key={error} className='contact-us-error-text'>{errors[error]}</p>;
					})}
				</div>
				<Button type="button" className="red-text" data-dismiss="alert" onClick={() => this.closeErrors()}>
					<span>×</span>
				</Button>
			</div>
		);
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state, process.env, settings);

		return (
			<Fragment>
				<LandingHeader history={this.props.history} />
				<Heading title={this.props.intl.formatMessage(localeMessages.contact_us_title)} />

				<ContentSection addedSectionClass='white-bg contact-us-container'>
					<form onSubmit={this.sendMessage}>
						<PageLoader addedClass="pilotly-blue-background" loading={this.state.loading} small={true} />

						<Row className='white-bg'>
							{Object.keys(this.state.messages).length > 0 ? <Col className='contact-us-messages-container' s={12}>
								{this.renderMessages(this.state.messages)}
							</Col> : null}
							{Object.keys(this.state.errors).length > 0 ? <Col className='contact-us-errors-container' s={12}>
								{this.renderErrors(this.state.errors)}
							</Col> : null}
							<Input 
								name='name' 
								onChange={this.handleContactChange} 
								className='contact-us-input-border' 
								s={12} m={6} l={6} 
								label={this.props.intl.formatMessage(localeMessages.contact_us_form_name)}
								value={this.state.contact.name} />
							<Input 
								name='email' 
								onChange={this.handleContactChange} 
								type="email" 
								label={this.props.intl.formatMessage(localeMessages.contact_us_form_email)}
								s={12} m={6} l={6} 
								value={this.state.contact.email} />
							<Input 
								name='phone' 
								onChange={this.handleContactChange} 
								type="text" 
								label={this.props.intl.formatMessage(localeMessages.contact_us_form_phone)}
								s={12} m={6} l={6} 
								value={this.state.contact.phone} />
							<Input 
								name='subject' 
								onChange={this.handleContactChange} 
								s={12} m={6} l={6} 
								type='select' 
								label={this.props.intl.formatMessage(localeMessages.contact_us_form_subject)}
								defaultValue='1'>
								<option className='blue' value='General Inquiry'>General Inquiry</option>
								<option className='blue' value='Submit Bug'>Submit Bug</option>
							</Input>

							<Input 
								name='message' 
								onChange={this.handleContactChange} 
								type='textarea' 
								placeholder={this.props.intl.formatMessage(localeMessages.contact_us_form_message)} 
								s={12} 
								value={this.state.contact.message} />
							
							<Button className='zhigh' waves='light' type='submit' onClick={this.sendMessage}>
								{this.props.intl.formatMessage(localeMessages.contact_us_button_send)}
							</Button>
						</Row>
					</form>
				</ContentSection>

				<LandingFooter />
			</Fragment>
		);
	}
}

export default injectIntl(ContactUs);


// WEBPACK FOOTER //
// ./src/pages/ContactUs.js